/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: bvRZj1oZhhFBeMnkX2LkQu
// Component: 9c2uJ0XQl9b8

import * as React from "react";

import Head from "next/head";
import Link, { LinkProps } from "next/link";
import { useRouter } from "next/router";

import {
  Flex as Flex__,
  MultiChoiceArg,
  PlasmicDataSourceContextProvider as PlasmicDataSourceContextProvider__,
  PlasmicIcon as PlasmicIcon__,
  PlasmicImg as PlasmicImg__,
  PlasmicLink as PlasmicLink__,
  PlasmicPageGuard as PlasmicPageGuard__,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  Stack as Stack__,
  StrictProps,
  Trans as Trans__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  generateOnMutateForSpec,
  generateStateOnChangeProp,
  generateStateOnChangePropForCodeComponents,
  generateStateValueProp,
  get as $stateGet,
  hasVariant,
  initializeCodeComponentStates,
  initializePlasmicStates,
  makeFragment,
  omit,
  pick,
  renderPlasmicSlot,
  set as $stateSet,
  useCurrentUser,
  useDollarState,
  usePlasmicTranslator,
  useTrigger,
  wrapWithClassName
} from "@plasmicapp/react-web";
import {
  DataCtxReader as DataCtxReader__,
  useDataEnv,
  useGlobalActions
} from "@plasmicapp/react-web/lib/host";

import { _useGlobalVariants } from "./plasmic"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/projectModule
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import sty from "./PlasmicAccordionSectionSplashImage.module.css"; // plasmic-import: 9c2uJ0XQl9b8/css

createPlasmicElementProxy;

export type PlasmicAccordionSectionSplashImage__VariantMembers = {
  product: "myEvaluations" | "myCme" | "myGme";
};
export type PlasmicAccordionSectionSplashImage__VariantsArgs = {
  product?: SingleChoiceArg<"myEvaluations" | "myCme" | "myGme">;
};
type VariantPropType = keyof PlasmicAccordionSectionSplashImage__VariantsArgs;
export const PlasmicAccordionSectionSplashImage__VariantProps =
  new Array<VariantPropType>("product");

export type PlasmicAccordionSectionSplashImage__ArgsType = {};
type ArgPropType = keyof PlasmicAccordionSectionSplashImage__ArgsType;
export const PlasmicAccordionSectionSplashImage__ArgProps =
  new Array<ArgPropType>();

export type PlasmicAccordionSectionSplashImage__OverridesType = {
  splashImage?: Flex__<typeof PlasmicImg__>;
};

export interface DefaultAccordionSectionSplashImageProps {
  product?: SingleChoiceArg<"myEvaluations" | "myCme" | "myGme">;
  className?: string;
}

const $$ = {};

function useNextRouter() {
  try {
    return useRouter();
  } catch {}
  return undefined;
}

function PlasmicAccordionSectionSplashImage__RenderFunc(props: {
  variants: PlasmicAccordionSectionSplashImage__VariantsArgs;
  args: PlasmicAccordionSectionSplashImage__ArgsType;
  overrides: PlasmicAccordionSectionSplashImage__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const __nextRouter = useNextRouter();

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const stateSpecs: Parameters<typeof useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "product",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => $props.product
      }
    ],
    [$props, $ctx, $refs]
  );

  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $q: {},
    $refs
  });

  const styleTokensClassNames = _useStyleTokens();

  return (
    <PlasmicImg__
      data-plasmic-name={"splashImage"}
      data-plasmic-override={overrides.splashImage}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      alt={""}
      className={classNames(
        "root_reset_bvRZj1oZhhFBeMnkX2LkQu",
        "plasmic_default_styles",
        "plasmic_mixins",
        styleTokensClassNames,
        sty.splashImage,
        {
          [sty.splashImageproduct_myCme]: hasVariant(
            $state,
            "product",
            "myCme"
          ),
          [sty.splashImageproduct_myEvaluations]: hasVariant(
            $state,
            "product",
            "myEvaluations"
          ),
          [sty.splashImageproduct_myGme]: hasVariant($state, "product", "myGme")
        }
      )}
      displayHeight={"auto"}
      displayMaxHeight={"none"}
      displayMaxWidth={"100%"}
      displayMinHeight={"0"}
      displayMinWidth={"0"}
      displayWidth={"100%"}
      loader={"plasmic"}
      loading={"lazy"}
      src={
        hasVariant($state, "product", "myGme")
          ? {
              src: "https://site-assets.plasmic.app/bf7dc75f24deabb714f8f4f09c333a17.svg",
              fullWidth: 267,
              fullHeight: 150,
              aspectRatio: 1.778607
            }
          : hasVariant($state, "product", "myCme")
            ? {
                src: "https://site-assets.plasmic.app/40ab4d39eb38cf1cbbe2e5426de8f647.svg",
                fullWidth: 715,
                fullHeight: 402,
                aspectRatio: 1.778607
              }
            : {
                src: "https://site-assets.plasmic.app/7f520bc0eb0db5cad28025956ef7d380.svg",
                fullWidth: 267,
                fullHeight: 150,
                aspectRatio: 1.778607
              }
      }
    />
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  splashImage: ["splashImage"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  splashImage: typeof PlasmicImg__;
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicAccordionSectionSplashImage__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicAccordionSectionSplashImage__VariantsArgs;
    args?: PlasmicAccordionSectionSplashImage__ArgsType;
    overrides?: NodeOverridesType<T>;
  } &
    // Specify variants directly as props
    Omit<PlasmicAccordionSectionSplashImage__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicAccordionSectionSplashImage__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicAccordionSectionSplashImage__ArgProps,
          internalVariantPropNames:
            PlasmicAccordionSectionSplashImage__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicAccordionSectionSplashImage__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "splashImage") {
    func.displayName = "PlasmicAccordionSectionSplashImage";
  } else {
    func.displayName = `PlasmicAccordionSectionSplashImage.${nodeName}`;
  }
  return func;
}

export const PlasmicAccordionSectionSplashImage = Object.assign(
  // Top-level PlasmicAccordionSectionSplashImage renders the root element
  makeNodeComponent("splashImage"),
  {
    // Helper components rendering sub-elements

    // Metadata about props expected for PlasmicAccordionSectionSplashImage
    internalVariantProps: PlasmicAccordionSectionSplashImage__VariantProps,
    internalArgProps: PlasmicAccordionSectionSplashImage__ArgProps
  }
);

export default PlasmicAccordionSectionSplashImage;
/* prettier-ignore-end */
